import { Dropdown } from "antd";
import { NavLink, useNavigate } from "react-router-dom";

import { Avatar } from "./Avatar";
import { useAuthStore } from "../store/auth";
import { authApi } from "../api/auth";

const ADMIN_LINKS = [
  { label: "Dashboard", to: "/dashboard" },
  { label: "Orders", to: "/orders" },
  { label: "Returns", to: "/returns" },
  { label: "Employees", to: "/employees" },
  { label: "Attendance", to: "/attendance" },
  { label: "Shops", to: "/shops" },
  { label: "Collection", to: "/collection" },
  { label: "Inventory", to: "/catalog" },
  { label: "Tasks", to: "/tasks" },
  { label: "Reports", to: "/reports" },
];

const SUPER_LINKS = [
  { label: "Admins", to: "/admins" },
  { label: "Enterprises", to: "/enterprises" },
  { label: "Audit Log", to: "/audit" },
  { label: "App Releases", to: "/releases" },
];

export function TopNav() {
  const { user, refreshToken, logout } = useAuthStore();
  const navigate = useNavigate();
  if (!user) return null;
  const links = user.role === "superuser" ? SUPER_LINKS : ADMIN_LINKS;

  const onLogout = async () => {
    try {
      if (refreshToken) await authApi.logout(refreshToken);
    } catch {
      // ignore
    }
    logout();
    navigate("/login");
  };

  return (
    <div className="topnav">
      <div className="topnav-wordmark">ERPMan</div>
      <div className="topnav-links">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) => `topnav-link${isActive ? " active" : ""}`}
          >
            {l.label}
          </NavLink>
        ))}
      </div>
      <div className="topnav-right">
        <Dropdown
          menu={{
            items: [
              { key: "profile", label: <span>{user.full_name}<div className="small-muted">{user.email}</div></span>, disabled: true },
              { type: "divider" },
              { key: "change-password", label: "Change Password", onClick: () => navigate("/change-password") },
              { type: "divider" },
              { key: "logout", label: "Logout", danger: true, onClick: onLogout },
            ],
          }}
          trigger={["click"]}
          placement="bottomRight"
        >
          <div style={{ cursor: "pointer" }}>
            <Avatar name={user.full_name} size={32} />
          </div>
        </Dropdown>
      </div>
    </div>
  );
}
